<style scoped lang="scss">
    .col-md-12{
      padding:12px 0;
    }
    .col-12{
      padding:12px 0;
    }
  .regist-popup{
    >.ui-row{
      padding:0;
      margin:0;
    }
    .ui-col{
      padding:12px 0;
    }
    
  }
</style>
<template>
  <div class="regist-popup">
    <v-row class="ui-row">
        <v-col
            cols="12"
            md="12"
            class="ui-col"
        >
            <input
            type="text"
            class="default-input input margin-left"
            id="company-name"
            style="width:100%"
            placeholder="고객코드 또는 고객명"
            v-model="custInput"
            v-on:keyup.enter="searchCustInfo()"
            />
            <div class="data-control" style="width:auto">
              <button type="button" class="search-btn" @click="searchCustInfo()">
                  <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="#ffffff"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg>
                  검색
              </button>
            </div>
        </v-col>
        <v-col
            cols="12"
            md="12"
            class="ui-col"
        >
            <div id="cust-pop-modal" class="real-grid"></div>  
        </v-col>
    </v-row>
  </div>
</template>
<script>

import { GridView, LocalDataProvider } from 'realgrid'
import { custFields, custColumns } from '../views/gridData/CustPopup.js'
import { mapGetters } from 'vuex'

let gridView = GridView
let localDataProvider = LocalDataProvider

export default {
  name: 'CustPopup',
  props : {
    selectCustEvent : Function
  },
  data() {
    return {
      custList: [],
      custInput: ''
    }
  },
  methods: {

    getCustPopup() {
      this.custInput = ''
      this.custList = []
      // console.log(this.custInfoObj)
      for(var i=0; i<this.custInfoObj.length; i++){
        var item = {'custCd' : this.custInfoObj[i].custCd, 'custNm' : this.custInfoObj[i].custNm, 'custAddr' : this.custInfoObj[i].custAddr1 }
        if(this.custList.findIndex((items) => items.custCd == this.custInfoObj[i].custCd) === -1){
          this.custList.push(item)
        }
      }
      localDataProvider.setRows(this.custList)
    },
    searchCustInfo() {
        // console.log(this.custInput)
        var tmpArr = []
        for (var i=0; i<this.custList.length; i++) {
            
            if (this.custList[i].custCd.indexOf(this.custInput) !== -1) {
                tmpArr.push(this.custList[i])
                continue
            }

            if (this.custList[i].custNm.indexOf(this.custInput) !== -1) {
                tmpArr.push(this.custList[i])
            }
        }
        localDataProvider.setRows(tmpArr)
    }
  },
  mounted() {
    setTimeout(() => {
      localDataProvider = new LocalDataProvider(false)
      gridView = new GridView('cust-pop-modal')
      gridView.setDataSource(localDataProvider)
      gridView.setCheckBar({
        visible: false
      })
      gridView.setStateBar({
        visible: false
      })
      gridView.setFooters({
        visible: false
      })
      localDataProvider.setFields(custFields)
      gridView.setColumns(custColumns)

      gridView.displayOptions.fitStyle = "even"
      gridView.displayOptions.selectionStyle = "singleRow"

      var tmpThis = this

      gridView.onCellDblClicked = function (grid, clickData) {
        // console.log('clickData = ' + JSON.stringify(clickData))
        //console.log(grid)
        if(clickData.cellType !== 'header' && clickData.cellType !== 'head'){
          var idx = clickData.dataRow
          var obj = localDataProvider.getJsonRow(idx)
          // console.log('click ----')
          // console.log(obj)
          tmpThis.$emit('selectCustEvent', obj)
        }
      }

      this.custInput = ''
      this.getCustPopup()
    }, 500)
  },
  computed: {
    ...mapGetters({
      custInfoObj: 'getCustMstData'
    })
  },
}
</script>